import Enum from './enum'

//児童ふり返りシート質問タイプ：２択アイコン エンティティー
class IconTypeTwo extends Enum {
    static GOOD = 'good';
    static BAD = 'bad';

    static values() {
        return {
            [this.GOOD]: 'bi-emoji-laughing',
            [this.BAD]: 'bi-emoji-dizzy',
        }
    }
}

export default IconTypeTwo;
